// extracted by mini-css-extract-plugin
module.exports = {"content":"TextImage_content__jG0vd","media":"TextImage_media__pc11p","text":"TextImage_text__Y3I0B"};